import { h } from 'preact'
import Icon, { IconType } from '../assets/index'

type Props = {
  isEnabled: boolean,
  direction?: string
}

const Sorting = ({ isEnabled, direction } : Props) => {
  let icon: IconType = 'sort'

  if (isEnabled && direction === 'asc') {
    icon = 'arrowDropUp'
  }

  if (isEnabled && direction === 'desc') {
    icon = 'arrowDropdown'
  }

  return <Icon icon={icon} height={16} width={16} customClass={!isEnabled ? 'inactive' : ''} />
}

export default Sorting
